import _implicitStylesheets from "./starRatings.css";
import _implicitScopedStylesheets from "./starRatings.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="no-reviews-text${0}" type-style="body-3"${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<b${3}>${"t1"}</b>`;
const $fragment3 = parseFragment`<span aria-hidden="true" class="rating-label${0}"${2}>${"t1"}</span>`;
const $fragment4 = parseFragment`<div class="showError${0}"${2}>${"t1"}</div>`;
const stc0 = {
  attrs: {
    "name": "label"
  },
  key: 4
};
const stc1 = [];
const stc2 = {
  classMap: {
    "average-rating": true
  },
  attrs: {
    "type-style": "body-3",
    "aria-hidden": "true"
  },
  key: 5
};
const stc3 = {
  classMap: {
    "reviews-link": true
  },
  attrs: {
    "name": "reviews-link"
  },
  key: 8
};
const stc4 = {
  "star-container": true
};
const stc5 = {
  "star": true
};
const stc6 = {
  "star-input": true
};
const stc7 = {
  "icon": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, ncls: api_normalize_class_name, gid: api_scoped_id, s: api_slot, h: api_element, t: api_text, ti: api_tab_index, b: api_bind, k: api_key, c: api_custom_element, i: api_iterator, f: api_flatten} = $api;
  const {_m0, _m1} = $ctx;
  return [$cmp.showNoReviewsText ? api_static_fragment($fragment1, 1, [api_static_part(1, null, api_dynamic_text($cmp.noReviewsText))]) : null, !$cmp.showNoReviewsText ? api_element("div", {
    className: api_normalize_class_name($cmp.componentClassNames),
    key: 2
  }, [api_element("label", {
    attrs: {
      "id": api_scoped_id("star-rating-label")
    },
    key: 3
  }, [api_slot("label", stc0, stc1, $slotset)]), !$cmp.isSingleReview ? api_element("span", stc2, [api_static_fragment($fragment2, 7, [api_static_part(1, null, api_dynamic_text($cmp.value))]), api_text(" ("), $cmp.linkReviews ? api_slot("reviews-link", stc3, stc1, $slotset) : null, !$cmp.linkReviews ? api_text(api_dynamic_text($cmp.reviewCount)) : null, api_text(")")]) : null, api_element("div", {
    classMap: stc4,
    attrs: {
      "role": $cmp.containerRole,
      "aria-label": $cmp.ariaLabelText,
      "tabindex": api_tab_index($cmp.starsTabIndex),
      "required": $cmp.required,
      "aria-required": $cmp.required
    },
    key: 9,
    on: {
      "keydown": _m0 || ($ctx._m0 = api_bind($cmp.onKeyDown))
    }
  }, api_flatten([api_iterator($cmp.starsArray, function (star) {
    return api_element("div", {
      classMap: stc5,
      attrs: {
        "data-rating": star.value,
        "id": api_scoped_id(star.id)
      },
      key: api_key(10, star.id),
      on: {
        "click": _m1 || ($ctx._m1 = api_bind($cmp.onStarClicked))
      }
    }, [api_element("input", {
      classMap: stc6,
      attrs: {
        "aria-label": star.ariaLabel,
        "disabled": $cmp.readOnly ? "" : null,
        "type": "radio",
        "name": "rating",
        "data-rating": star.value,
        "tabindex": "-1"
      },
      props: {
        "checked": star.checked,
        "value": star.value
      },
      key: 11
    }), api_custom_element("ax-icon", _axIcon, {
      classMap: stc7,
      props: {
        "icon": "favorite",
        "size": $cmp.size,
        "gradient": star.gradient,
        "ariaHidden": true
      },
      key: 12
    })]);
  }), $cmp.ratingLabel ? api_static_fragment($fragment3, 14, [api_static_part(1, null, api_dynamic_text($cmp.ratingLabel))]) : null])), $cmp.forceShowError ? api_static_fragment($fragment4, 16, [api_static_part(1, null, api_dynamic_text($cmp.errorMessage))]) : null]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["label", "reviews-link"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-352p7t9829q";
tmpl.legacyStylesheetToken = "undefined-_starRatings";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
